<template>
  <LeadStatusesPage
    :title="`${__('autonomia', 'settings')} - ${__('unidades', 'settings')}`"
    :description="`${__(
      'define os status que são considerados ativos para a unidade.',
      'settings'
    )}
    ${__(
      'esses status são utilizados para definir a carga de serviços',
      'settings'
    )}`"
    param-id="lead_statuses_active_for_unity"
  />
</template>

<script>
import LeadStatusesPage from "@/components/Lead/Statuses/LeadStatusesPage.vue";
import i18n from "@/mixins/i18n";

export default {
  mixins: [i18n],
  components: {
    LeadStatusesPage,
  },
};
</script>
